import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Observable, lastValueFrom } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AdminDictationsService } from '../../admin-dictations/admin-dictations.service';
import { TranscriptionCreateService } from '../../transcription-create/transcription-create.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BillerDashboardService } from '../../biller-dashboard/biller-dashboard.service';
import { MatDialog } from '@angular/material/dialog';
import { UserTypesRelationshipService } from 'src/app/services/user-types-relationship.service';
import { startWith, map } from 'rxjs/operators';
import { CensusNotesServiceService } from '../census-notes-service.service';
import { user } from '@ironcorelabs/ironweb';
import { HttpResponse } from '@angular/common/http';
import { CompanyService } from 'src/app/services/Modules/company.service';


interface IFilter {
  active: boolean,
  creation_date: {
    startDate: any | Date | moment.Moment,
    endDate: any | Date | moment.Moment
  },
  date_of_service: {
    startDate: any | Date | moment.Moment,
    endDate: any | Date | moment.Moment
  },
  user: string,
  facility: string,
  patient: string,
  progress_status: string
}

@Component({
  selector: 'app-census-notes',
  templateUrl: './census-notes.component.html',
  styleUrls: ['./census-notes.component.css']
})
export class CensusNotesComponent implements OnInit {
  filteredFacilities: Observable<string[]>;
  facilityControl = new FormControl();
  filteredProvider: Observable<string[]>;
  providerControl = new FormControl();
  
  global = global;
  public isVisibleTable: boolean = true;
  isVisibleDetailTable: boolean = false;
  public sortedData: Array<any>;
  public notes: Array<any>;
  public group_notes: Array<any>;
  public notesGroup;
  public sortNotesGroup;
  public c_user;
  chargesPopup: any;
  public c_date = moment(new Date());
  public creationDateFilter: Boolean = true;
  public serviceDateFilter: Boolean = true;
  displayedColumns: string[] = ['date_of_creation', 'patient_name', 'facility_title', 'dos', 'updatedAt', 'provider_name', 'census_name', 'progress_status', 'operation'];
  chargeStatus: string = 'default';
  @ViewChild(MatSort) sort: MatSort;

  provideModel: any = '';
  facilityMOdel: any = "";
  company_id: any;
  // filter: any = {
  //   creation_date: {
  //     startDate: moment().subtract(7, 'days').toDate(),
  //     endDate: moment().toDate()
  //   },
  //   date_of_service: null

  // };
  filter: any = {
    creation_date:null,
    date_of_service:  {
      startDate: moment().subtract(2, 'days'),
      endDate: moment()
    }

  };
  appliedFilter: IFilter;
  users: Array<any> = [];
  providers: Array<any> = [];
  note_types: Array<any> = [];
  facilities: Array<any> = [];
  patients: Array<any> = [];
  uniqueProviders: any = [];
  status = [
    { title: 'Unsigned' },
    { title: 'Signed' },
    { title: 'Uploaded' }
  ];
  filteredProviders: Observable<string[]>;


  preDateRanges: any = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  };

  currentDate = new Date();
  notesToShow = null;
  currentRouteUrl: any;
  charges: any = [];
  provider: any;
  facility: any;
  groupedDates: string[];
  groupedData: any = [];
  groupedCharges: any = [];
  dataSource: any = new MatTableDataSource([])
  totalRecords: number = 0;
  fitlerButtonClicked: boolean = false;
  censuses: any = [];
  showPccLogo: boolean = false;

  constructor(
    private _dictationService: AdminDictationsService,
    private _transcriptionCreateService: TranscriptionCreateService,
    private _authService: AuthService,
    private toastr: ToastrService,
    private _router: Router,
    private route: ActivatedRoute,
    private billerDashboardService: BillerDashboardService,
    private _censusNotesServiceService: CensusNotesServiceService,
    private dialog: MatDialog,
    public userTypesRelationshipService: UserTypesRelationshipService
  ) { }

  ngOnInit(): void {
    if (window.location.pathname.includes('company') && !window.location.pathname.includes('manage-companies')) {
      this.company_id = this.route.parent.parent.snapshot.params.id;
    }
    else if (window.location.pathname.includes('manage-companies')) {
      this.company_id = this.route.parent.parent.snapshot.params.id;
    }
    const isDOSFilterObj = JSON.parse(localStorage.getItem('census_dos_filter_obj'));
    if (isDOSFilterObj) {
      this.filter.date_of_service.startDate = moment(isDOSFilterObj.startDate);
      this.filter.date_of_service.endDate = moment(isDOSFilterObj.endDate);
    }
    const isProviderFilter = JSON.parse(localStorage.getItem('census_provider_filter'));
    if (isProviderFilter) {
      this.initFacilities(isProviderFilter);
      this.provider = isProviderFilter;
      this.filter.provider_id = isProviderFilter._id;
      this.providerControl.setValue(isProviderFilter.full_name);
    }
    const isFacilityFilter = JSON.parse(localStorage.getItem('census_facility_filter'));
    if (isFacilityFilter) {
      this.facility = isFacilityFilter;
      this.filter.facility_id = isFacilityFilter._id;
      if (isFacilityFilter.pcc_facId || isFacilityFilter.source === 'PointClickCare') {
        this.showPccLogo = true;
      } else {
        this.showPccLogo = false;
      }
      this.facilityControl.setValue(isFacilityFilter.title);
    }
    if (isProviderFilter || isFacilityFilter) {
      this.isVisibleDetailTable = false;
      this.isVisibleTable = true;
      this.fitlerButtonClicked = true;
    }
    this.getProviderList();
    this.initFacilities();
    this.initCensusChargeReport();
    this.filteredProviders = this.providerControl.valueChanges.pipe(
      startWith(''),
      map((value:any) => this.filterProvider(value)));
    this.filteredFacilities = this.facilityControl.valueChanges.pipe(
      startWith(''),
      map((value:any) => this.filterFacilities(value)));

  }

  clearProviderFilter(){
      this.provideModel = '';
      this.providerControl.setValue('');
  }
  clearFacilityFilter(){
      this.facilityMOdel = '';
      this.facilityControl.setValue('');
      this.showPccLogo = false;
  }
  getProvControlStatus(){
    if(this.providerControl?.value&&(this.providerControl?.value!='')) return true; else return false;
  }
  getFacControlStatus(){
    if(this.facilityControl?.value&&(this.facilityControl?.value!='')) return true; else return false;
  }
  sortFirstNameVise(arrayTosort){
      let users=arrayTosort;
      let result=users.sort(function(a, b){
          if(a.first_name?.toLowerCase() < b.first_name?.toLowerCase()) { return -1; }
          if(a.first_name?.toLowerCase() > b.first_name?.toLowerCase()) { return 1; }
          return 0;
      })
      return result;
  }

  private filterFacilities(value: string): string[] {
    if (value) {
      const filterValue = value.toLowerCase();
      if(value.length == 1) {
        this.showPccLogo = false;
      }
      return this.facilities.filter(option => option.title.toLowerCase().indexOf(filterValue) === 0);
    }
    else {
      return this.facilities;
    }
  }

  private filterProvider(value: string): string[] {
    if (value && this.providers.length > 0) {
      const filterValue = value.toLowerCase();
      let users= this.providers.filter(option => (option.middle_name && option.middle_name.toLowerCase().indexOf(filterValue) === 0) || option.last_name.toLowerCase().indexOf(filterValue) === 0 || option.first_name.toLowerCase().indexOf(filterValue) === 0);
       return this.sortFirstNameVise(users);
    }
    else {
      return this.sortFirstNameVise(this.providers);
    }
  

  }

  initCensusChargeReport() { 
    this.filter.company_id = this.company_id; 
    this._censusNotesServiceService.getCensusChargesReport(this.filter).subscribe((response: any) => {
      if (response.status === 200) {
        this.censuses = response.data;
        this.totalRecords = 0;
        for (const group of this.censuses) {
          if (Array.isArray(group?.groupedData)) {
            for (const item of group?.groupedData) {
              this.totalRecords += item.census.length;
            }
          }
        }
        this.censuses = this.sortCensusesByCreationDate(this.censuses);
      }
    });
  }
  sortCensusesByCreationDate(censuses) {
    var byDate = censuses.slice(0);
    byDate.sort(function (a, b) {
      return a._id < b._id ? 1 : a._id > b._id ? -1 : 0;
    });
    return byDate;
  }
  getProviderList() {
    this.userTypesRelationshipService.getDoctorsList('true', this.company_id).subscribe((response: any) => {
      if (response.status === 200) {
        this.providers = response.data;
        if (this.providers.length > 0) {
          //this.providers.sort(this.sortProviders);
          this.providers=this.sortFirstNameVise(this.providers);

          this.filteredProviders = this.providerControl.valueChanges.pipe(
            startWith(''),
            map((value:any) => this.filterProvider(value)));
          // this.providerControl.setValue(this.providers[0].full_name);
          // this.filter.provider = this.providers[0];
        }
      }
    });
  }
  sortProviders(a, b) {
    if (a.first_name < b.last_name) {
      return -1;
    }
    if (a.first_name > b.last_name) {
      return 1;
    }
    return 0;
  }
  async initFacilities(provider = null) {
    let response: any = {};
    if (provider) {
      response = await this._transcriptionCreateService.getFacilities(provider._id).toPromise();
    }
    if (response.status === 200) {
      this.facilities = response.data.array;
      this.filteredFacilities = this.facilityControl.valueChanges.pipe(
        startWith(''),
        map((value:any) => this.filterFacilities(value))
      );
    }
  }
  
  changeServiceDate(event) {
    if (event.startDate && event.endDate) {
      let census_dos_filter_obj = {
        startDate: moment(event.startDate),
        endDate: moment(event.endDate)
      }
      localStorage.setItem('census_dos_filter_obj', JSON.stringify(census_dos_filter_obj));
      this.filter.date_of_service = {
        startDate: null,
        endDate: null
      }
      this.filter.date_of_service.startDate = event.startDate;
      this.filter.date_of_service.endDate = event.endDate;
      let startDate = moment(event.startDate);
      let endDate = moment(event.endDate);
      let noOfDays = endDate.diff(startDate, 'days');
      if (noOfDays > 30) {
        this.serviceDateFilter = false;
        this.filter.date_of_service.endDate = moment(this.filter.date_of_service?.startDate).add(29, "days").startOf('day');
        endDate = this.filter.date_of_service.endDate;
        this.toastr.error('Can not select more than 30 days', 'ERROR');

        setTimeout(() => {
          this.serviceDateFilter = true;
        }, 300)
      }
    }
  }

  onSelectProvider(item = null) {
    if (item) {
      localStorage.setItem('census_provider_filter', JSON.stringify(item));
      this.initFacilities(item);
      this.provider = item;
      this.filter.provider_id = item._id;
    }
    // if ($event.isUserInput) {
    //   this.initFacilities(provider);
    //   this.filter.provider_id = provider._id;
    //   this.providerControl.setValue(provider.full_name);
    // }
  }
  onSelectFacility(item = null) {
    if (item) {
      localStorage.setItem('census_facility_filter', JSON.stringify(item));
      this.facility = item;
      this.filter.facility_id = item._id;

      if (item.pcc_facId || item.source === 'PointClickCare') {
        this.showPccLogo = true;
      } else {
        this.showPccLogo = false;
      }
    }
  }

  changeCreationDate(event) {
    var startDate = moment(event.startDate);
    var endDate = moment(event.endDate);
    var noOfDays = endDate.diff(startDate, 'days');
    if (noOfDays > 30) {
      this.creationDateFilter = false;
      this.filter.creation_date.endDate = moment(this.filter.creation_date.startDate).add(29, "days").startOf('day');
      endDate = this.filter.creation_date.endDate;
      this.toastr.error('Can not select more than 30 days', 'ERROR');

      setTimeout(() => {
        this.creationDateFilter = true;
      }, 300)
    }
  }
  getDate(date) {
    return moment(new Date(date)).format('MMM DD, YYYY');
  }
  totalCount(groupedData) {
    if (Array.isArray(groupedData)) {
      let totalCount = 0;
      for (let i = 0; i < groupedData.length; i++) {
        totalCount += groupedData[i]?.chargeList?.count;
      }
      return totalCount;
    }
  }
  handleApplyFilterClick() {
    this.isVisibleDetailTable = false;
    this.isVisibleTable = true;
    this.fitlerButtonClicked = true;
    if (!this.providerControl.value) {
      this.provider = undefined;
      delete this.filter?.provider_id;
    }
    if (!this.facilityControl.value) {
      this.facility = undefined;
      delete this.filter?.facility_id;
    }
    this.initCensusChargeReport();
  }
  resetFilter() {
    this.chargeStatus = 'default';
    this.fitlerButtonClicked = false;
    this.provider = undefined;
    this.facility = undefined;
    this.showPccLogo = false;
    this.isVisibleDetailTable = false;
    this.isVisibleTable = true;
    delete this.filter?.creation_date;
    delete this.filter?.provider_id;
    delete this.filter?.facility_id;
    delete this.filter?.status;
    this.filter.date_of_service = {
      startDate: moment().subtract(2, 'days'),
      endDate: moment(),
    }
    this.filter.creation_date = null;
    this.providerControl.setValue("");
    this.facilityControl.setValue("");
    this.initCensusChargeReport();
    localStorage.removeItem('census_dos_filter_obj');
    localStorage.removeItem('census_provider_filter');
    localStorage.removeItem('census_facility_filter');
  }
  getVisitDate(date) {
    return moment(new Date(date).toLocaleString('en-US', { timeZone: 'America/Los_Angeles' })).format('MMM DD, YYYY h:mm a');
  }
  getNotesCount(census) {
    let [signedCount, savedCount] = [0, 0];
    if (Array.isArray(census?.notes) && census.notes.length > 0) {
      for (const note of census.notes) {
        if (note?.note_status?.status === "in_progress" || note?.note_status?.status === "internal_qa" || note?.note_status?.status === "external_qa" || note?.note_status?.status === "draft_save" || note?.note_status?.status === "published") {
          savedCount++;
        }
        else if (note?.note_status?.status === "signed" || note?.note_status?.status === "uploaded" || note?.note_status?.status === "not_uploaded") {
          signedCount++;
        }
      }
      return `${savedCount} / ${signedCount}`;
    }
    else {
      return `${savedCount} / ${signedCount}`;
    }
  }
  getChargesCount(census) {
    let [draftCount, submittedCount] = [0, 0];
    if (Array.isArray(census.charges) && census.charges.length > 0) {
      for (const charge of census.charges) {
        if (charge.status === "draft") {
          draftCount++;
        }
        else if (charge.status === "submit" || charge.bill_status === "billed") {
          submittedCount++;
        }
      }
      return `${draftCount} / ${submittedCount}`;
    }
    else {
      return `${draftCount} / ${submittedCount}`;
    }
  }
  showStatus(census) {
    let submittedCount: any = 0;
    let signedCount: any = 0;
    if (Array.isArray(census?.charges) && census.charges.length > 0) {
      submittedCount = census.charges.reduce((accumulater, current) => current.status === "submit" ? ++accumulater : accumulater, submittedCount);
    }

    if (Array.isArray(census?.notes) && census.notes.length > 0) {
      signedCount = census.notes.reduce((accumulater, current) => {
        return (current?.note_status?.status === "signed" ||
          current?.note_status?.status === "uploaded" ||
          current?.note_status?.status === "not_uploaded") ? ++accumulater : accumulater
      }, signedCount)
    }
    if (submittedCount === signedCount) {
      return 'green';
    }
    else if (submittedCount < signedCount) {
      return 'red';
    }
    else if (submittedCount > signedCount) {
      return 'yellow';
    }
  }
  redirectToCensusScreen(census) {
    // if (this._authService.currentUser._id === census?.createdBy?._id && census?._id) {
      this._router.navigate([`/census/${census._id}`]);
    // }
  }
  redirectToChargeScreen(census) {
    // if (this._authService.currentUser._id === census?.createdBy?._id) {
      // this._router.navigate([`company/${this.company_id}/user-management/doctor-profile`, { provider_id: census.createdBy._id, census: true, facility_id: census.facility._id }]);
      this._router.navigate([`/census/${census._id}`]);
    // }
  }

  
  exportCensusReportAsExcel() {
    this._censusNotesServiceService.exportCensusReportAsExcel(this.censuses).subscribe((data: any) => {
      if (data instanceof HttpResponse) {
        // console.log("in httpresponse")
        var url = window.URL.createObjectURL(data.body);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = 'Census-Report';
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
      }
      else {
        // console.log("in else")
        if (data.type === 0) {
        } else if (data.type === 3) {
          const { loaded, total } = data;
          const progress = Math.round(loaded / total * 100);
          if (progress > 0) {
          }
        }
      }
      if (data.status == 200) {
        // console.log("in status")
        return true;
      }
    })
  }
}
